import type {Context} from '../types';

/**
 * This patch removes data.widget.annotation from GooglePlus node
 */

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const hasAnnotation = data.widget && data.widget.annotation !== undefined;

  return {
    needed: hasAnnotation,
    logData: {
      msg: 'GooglePlus widget node with data.widget.annotation',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.widget.annotation;
    },
  };
};
